import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import { AuthProvider } from './context/AuthContext';
import { AppInsightsProvider } from './context/AppInsightsContext';
import AppErrorBoundary from './components/AppErrorBoundary';
import AppInsightsRouteTracker from './components/AppInsightsRouteTracker';
import './i18n/config';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <AppErrorBoundary>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <AuthProvider>
          <AppInsightsProvider>
            <AppInsightsRouteTracker>
              <App />
            </AppInsightsRouteTracker>
          </AppInsightsProvider>
        </AuthProvider>
      </BrowserRouter>
    </AppErrorBoundary>
  </React.StrictMode>
);
